// extracted by mini-css-extract-plugin
export var container = "_hb-0";
export var content = "_hb-3";
export var customerTitle = "_hb-4";
export var empty = "_hb-5";
export var gray = "_hb-6";
export var header = "_hb-7";
export var info = "_hb-8";
export var loading = "_hb-2";
export var loadingCard = "_hb-9";
export var oneLine = "_hb-a";
export var personName = "_hb-e";
export var pillContainer = "_hb-b";
export var selected = "_hb-1";
export var text = "_hb-c";
export var twoLines = "_hb-d";
export var unread = "_hb-f";
export var unreadIndicator = "_hb-g";